module.exports = __webpack_public_path__ + "media/images/general/icon_eye-e57aab4efdce41a8cc7cd0df794b4ba8.svg";